import tmarked from "marked";
import hmarked from "marked";

// https://marked.js.org/#/USING_PRO.md

const tRenderer = new tmarked.Renderer();

tRenderer.paragraph = text => text + "\n\n";

let links = [];
tRenderer.link = (href, title, text) => {
  links.push(href);
  return `${text}[${links.length}]`;
};
tRenderer.image = (href, title, text) => {
  links.push(href);
  return `${text}[${links.length}]`;
};

tRenderer.br = () => "\n";
tRenderer.strong = text => `**${text}**`;
tRenderer.em = text => `*${text}*`;
tRenderer.text = text =>
  text.replace(/\&\#39;/g, "'").replace(/\&quot\;/g, '"');
tRenderer.hr = () => "---\n\n";
tRenderer.list = (body, ordered, start) => body + "\n";
tRenderer.listitem = text => `* ${text}\n`;

tmarked.setOptions({
  renderer: tRenderer,
});

const toText = markdown => {
  links = [];
  return (
    tmarked(markdown, { renderer: tRenderer }) +
    "\n---\n\n" +
    links.map((link, i) => `${i + 1}. ${link}`).join("\n")
  );
};

hmarked.setOptions({
  renderer: new hmarked.Renderer(),
  breaks: true,
});

const toHtml = markdown => {
  return hmarked(markdown);
};

export { toText, toHtml };



// WEBPACK FOOTER //
// ./src/MarkdownRenderers.js